import { Entity } from '@backstage/catalog-model';
import { GlitchtipPerformanceResult } from '../types';
import { GLITCHTIP_PERFORMANCE_URL } from '../constants';

export const usePerformanceEntity = (entity: Entity): GlitchtipPerformanceResult => {
  try {
    const url = entity.metadata?.annotations?.[GLITCHTIP_PERFORMANCE_URL];
    // const url = "https://monitor.dev.sev-2.com/demo/performance/transaction-groups?project=10"

    if (!url) {
      return {
        success: false,
        error: 'No performance URL annotation found. Please add the glitchtip/performance-check-url annotation to your entity.',
        data: null,
      };
    }

    // Validate URL format
    let urlObj: URL;
    try {
      urlObj = new URL(url);
    } catch {
      return {
        success: false,
        error: 'Invalid URL format in performance annotation.',
        data: null,
      };
    }

    const host = urlObj.hostname;

    // Extract org and project ID from URL
    // Expected format: /org/performance/transaction-groups?project=123
    const urlPattern = /\/([^\/]+)\/performance\/transaction-groups\?project=(\d+)/;
    const match = url.match(urlPattern);

    if (!match) {
      return {
        success: false,
        error: 'URL format does not match expected pattern: /org/performance/transaction-groups?project=id',
        data: null,
      };
    }

    const org = match[1];
    const projectId = match[2];

    return {
      success: true,
      data: {
        performanceUrl: url,
        host,
        org,
        projectId,
      },
    };
  } catch (error) {
    return {
      success: false,
      error: `Unexpected error parsing entity: ${error instanceof Error ? error.message : 'Unknown error'}`,
      data: null,
    };
  }
};